import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Callback from './callback';
import CallbackDeleteDialog from './callback-delete-dialog';
import CallbackDetail from './callback-detail';
import CallbackUpdate from './callback-update';

const CallbackRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Callback />} />
    <Route path="new" element={<CallbackUpdate />} />
    <Route path=":id">
      <Route index element={<CallbackDetail />} />
      <Route path="edit" element={<CallbackUpdate />} />
      <Route path="delete" element={<CallbackDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default CallbackRoutes;
